import React from 'react';
import { Progress, List, theme } from 'antd';
import { useTranslation } from 'react-i18next';

import { EPButton } from '@/components';
import { BucketCard, BucketHeader, BucketContent } from './styled';
import { MissingImagesProps } from './StationReadinessScore.utils';

const MissingImages: React.FC<MissingImagesProps> = ({
  percentage,
  totalComponents,
  missingComponents,
  images = [],
  onAddImages,
  isLoading = false,
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  const handleAddImages = (imageId: string) => {
    if (onAddImages) {
      onAddImages(imageId);
    }
  };

  return (
    <BucketCard>
      <BucketHeader>
        <div className="bucket-title">
          <div className="title-text">
            {t('Missing')} {images.reduce((total, img) => total + img.imageTypes.length, 0)} {t('images')} ({missingComponents}/{totalComponents} {t('comps')})
          </div>
        </div>
        <div className="bucket-progress">
          <div className="percentage-text">{percentage}%</div>
          <Progress
            type="circle"
            percent={percentage}
            size={20}
            strokeWidth={12}
            strokeLinecap="square"
            showInfo={false}
            strokeColor={token.colorWhite}
            trailColor={token.colorFillSecondary}
          />
        </div>
      </BucketHeader>

      <BucketContent>
        <List
          itemLayout="vertical"
          dataSource={images}
          split={false}
          renderItem={(image) => (
            <List.Item key={image.id} className="spec-item">
              <div className="item-content">
                <div className="text-wrapper">
                  <div className="item-title">{image.name}</div>
                  <div className="item-description">
                    {image.imageTypes.map((type, index) => (
                      <div key={index}>{t(type)}</div>
                    ))}
                  </div>
                </div>
                <div className="item-actions">
                  <EPButton
                    type="link"
                    size="small"
                    onClick={() => handleAddImages(image.id)}
                    loading={isLoading}
                    className="action-link"
                  >
                    {t('Add images')}
                  </EPButton>
                </div>
              </div>
            </List.Item>
          )}
        />
      </BucketContent>
    </BucketCard>
  );
};

export default MissingImages;
